import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SidebarBaseComponent } from './sidebar-base.component';
import { CustomerService, NavigationService, StorageService } from '~core/services';

/**
 * Content for the customer search sidebar.
 */
@UntilDestroy()
@Component({
  selector: 'app-imports-sidebar',
  template: `
  <nav class="esf-app-menu esf-accordion">
    <div class="esf-app-menu__unit">
      <div class="esf-app-menu__item">
        <a i18n='Sidebar menu item@@sidebarComponent.menu.home'
          [routerLink]="['/club/' + this.selectedClub.id]">Home</a>
      </div>
      <div class="esf-app-menu__item" [ngClass]="{'-is-active': this.currentPage === 'imports'}">
        <a i18n='Sidebar menu item@@sidebarComponent.menu.imports'
        [routerLink]="['/club/' + this.selectedClub.id + '/imports']">Imports</a>
      </div>
      <div class="esf-app-menu__item" [ngClass]="{'-is-active': this.currentPage === 'importHistory'}">
        <a i18n='Sidebar menu item@@sidebarComponent.menu.importHistory'
        [routerLink]="['/club/' + this.selectedClub.id + '/import-history']">Import history</a>
      </div>
    </div>
  </nav>
  `
})
export class ImportsSidebarComponent extends SidebarBaseComponent implements OnDestroy {
  public currentPage: string;

  constructor(
    storage: StorageService,
    route: ActivatedRoute,
    navigationService: NavigationService,
    customerService: CustomerService,
    router: Router) {
    super(storage, route, navigationService, customerService, router);
    this.navigationService.castCurrentPage
      .pipe(untilDestroyed(this))
      .subscribe(data => this.currentPage = data);
  }

  public ngOnDestroy(): void { }
}
